import React from 'react'
import { connect } from "react-redux";

function ResumeSkill({resumeReducer, classname, position, skills }) {
    const {design} = resumeReducer
    function circle(range) {
        const ele = [];
        for (let i = 0; i < 5; i++) {
            let klass;
            let bgClass;
            if (range > i && range != null) {
                klass += " skillsSelected";
            }
            ele.push(<div key={i} id={bgClass} className={`${klass} w-2 h-2 rounded-full  bg-gray-200`} style={{"backgroundColor": klass && design.layout.background}}></div>)
        }
        return ele
    }
    return (
        <>
            <div className={`resumeDetail ${classname}`}>
                <div className='resumeDetail-heading'>
                    <p className={`font-bold border-b-2 border-solid ${position === 'left' ? 'border-white' : 'border-black'}`}>Skills</p>
                </div>
                {skills.map((data, idx) => {
                    const { skill, skillLevelRate } = data
                    return <div key={idx} className='flex items-center justify-between'>
                        <div>
                            <span className='text-xs font-bold'>{skill}</span>
                        </div>
                        <div className='flex space-x-2'>{circle(skillLevelRate)}</div>
                    </div>
                })}
            </div>
        </>
    )
}
const mapStateToProps = (state) => {
    return state;
};
export default connect(mapStateToProps, null)(ResumeSkill)